var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.525 8.19219L13.65 12.5422C12.675 13.0672 11.4 13.0672 10.425 12.5422L2.47495 8.19219C2.02495 7.96719 2.02495 7.36719 2.47495 7.14219L10.35 2.79219C11.325 2.26719 12.6 2.26719 13.575 2.79219L21.525 7.14219C21.975 7.36719 21.975 7.96719 21.525 8.19219Z",
    fill: "#6CCCDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.525 8.19219L13.65 12.5422C12.675 13.0672 11.4 13.0672 10.425 12.5422L2.47495 8.19219C2.02495 7.96719 2.02495 7.36719 2.47495 7.14219L10.35 2.79219C11.325 2.26719 12.6 2.26719 13.575 2.79219L21.525 7.14219C21.975 7.36719 21.975 7.96719 21.525 8.19219Z",
    fill: "url(#paint0_linear_6950_4194)",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5249 11.7923L20.0249 10.9673L13.6499 14.4923C12.6749 15.0173 11.3999 15.0173 10.4249 14.4923L4.0499 10.9673L2.5499 11.7923C2.0999 12.0173 2.0999 12.6173 2.5499 12.8423L10.4249 17.1923C11.3999 17.7173 12.6749 17.7173 13.6499 17.1923L21.5249 12.8423C21.9749 12.6173 21.9749 12.0173 21.5249 11.7923Z",
    fill: "#6CCCDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5249 11.7923L20.0249 10.9673L13.6499 14.4923C12.6749 15.0173 11.3999 15.0173 10.4249 14.4923L4.0499 10.9673L2.5499 11.7923C2.0999 12.0173 2.0999 12.6173 2.5499 12.8423L10.4249 17.1923C11.3999 17.7173 12.6749 17.7173 13.6499 17.1923L21.5249 12.8423C21.9749 12.6173 21.9749 12.0173 21.5249 11.7923Z",
    fill: "url(#paint1_linear_6950_4194)",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5249 16.5921L20.0249 15.7671L13.6499 19.2921C12.6749 19.8171 11.3999 19.8171 10.4249 19.2921L4.0499 15.7671L2.5499 16.5921C2.0999 16.8171 2.0999 17.4171 2.5499 17.6421L10.4249 21.9921C11.3999 22.5171 12.6749 22.5171 13.6499 21.9921L21.5249 17.6421C21.9749 17.4171 21.9749 16.8171 21.5249 16.5921Z",
    fill: "#6CCCDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5249 16.5921L20.0249 15.7671L13.6499 19.2921C12.6749 19.8171 11.3999 19.8171 10.4249 19.2921L4.0499 15.7671L2.5499 16.5921C2.0999 16.8171 2.0999 17.4171 2.5499 17.6421L10.4249 21.9921C11.3999 22.5171 12.6749 22.5171 13.6499 21.9921L21.5249 17.6421C21.9749 17.4171 21.9749 16.8171 21.5249 16.5921Z",
    fill: "url(#paint2_linear_6950_4194)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6950_4194",
    x1: 3.54638,
    y1: 1.52032,
    x2: 21.8998,
    y2: 2.56735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6950_4194",
    x1: 3.61597,
    y1: 10.4157,
    x2: 21.8101,
    y2: 12.0619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6950_4194",
    x1: 3.61597,
    y1: 15.2155,
    x2: 21.8101,
    y2: 16.8617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.fabc3d7f3d6b1853e08a1888d3326171.svg";
export { ForwardRef as ReactComponent };